module.exports = __webpack_public_path__ + "img/prizes.fab0419d.svg";